import * as MachineLearningDAO from './MachineLearningDAO';
import {
  ParameterOptimizationPredictionRequestData,
  ParameterOptimizationPredictionResponse,
} from './MachineLearningDAO';

export function trainParameterOptimization(
  data: MachineLearningDAO.TrainParameterOptimizationRequestData
): Promise<void> {
  return MachineLearningDAO.trainParameterOptimization(data);
}

export function runParameterOptimizationPrediction(
  input: ParameterOptimizationPredictionRequestData
): Promise<ParameterOptimizationPredictionResponse> {
  return MachineLearningDAO.runParameterOptimizationPrediction(input);
}
